import { InternalAxiosRequestConfig } from "axios";
import { getAuth0AccessToken } from "./auth0-token";

export class MissingAuthTokenError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "MissingAuthTokenError";
  }
}

export async function ensureAuthenticatedRequest(
  originalRequest: InternalAxiosRequestConfig,
): Promise<InternalAxiosRequestConfig> {
  const auth0Token = getAuth0AccessToken();
  if (auth0Token) {
    originalRequest.headers = originalRequest.headers || {};
    originalRequest.headers["Authorization"] = `Bearer ${auth0Token}`;
    return Promise.resolve(originalRequest);
  }

  return Promise.reject(new MissingAuthTokenError("No auth token available"));
}
